import { useMemo } from 'react';
import DataStoreOptions from './DataStoreOptions';
import useQueries from './useQueries';
import createDataStore from './createDataStore';

const useDataStore = <T>(options: DataStoreOptions<T>) => {
  const queries = useQueries<T>(options);

  const { filter, ...opt } = options;

  const dataStore = useMemo(
    () => createDataStore<T>(queries, options),
    [queries, JSON.stringify(filter || []), ...Object.values(opt)],
  );
  return dataStore;
};

export default useDataStore;
